import React from "react";
import {
  I2cAvatarGroup,
  I2cAvatar,
} from "@webcomponents/i2cwebcomponents/dist/react";

const isBase64 = (str) => {
  try {
    return btoa(atob(str)) === str;
  } catch (error) {
    return false;
  }
};
const getInitials = (name) => {
  // Split the name into words
  const words = name.split(" ");

  // Extract the first character of the first two words and convert them to uppercase
  const initials = words
    .slice(0, 2)
    .map((word) => word.charAt(0).toUpperCase());

  // Concatenate the initials
  return initials.join("");
};

const AvatarGroup = ({ assignedAvatars }) => {
  if (!assignedAvatars) return null;
  return (
    <I2cAvatarGroup
      maxCount="2"
      size="medium"
      layout="overlap"
      popover_layout="list"
    >
      {assignedAvatars.map((base64Img, index) => (
        <I2cAvatar
          key={index} // Ensure you provide a unique key for each component in a loop
          initials={isBase64(base64Img) ? "" : getInitials(base64Img)}
          slot="avatar"
          image={
            "data:image/jpeg;base64," + (isBase64(base64Img) ? base64Img : "")
          } // Fixed syntax
          size="medium"
          className="user-avatar1"
          name={isBase64(base64Img) ? "" : base64Img}
          label={isBase64(base64Img) ? "" : base64Img}
        />
      ))}
    </I2cAvatarGroup>
  );
};

export default AvatarGroup;
